module.exports = __webpack_public_path__ + "img/1979pigc.42c1d5c8.png";